import { z } from 'zod';
import { optionalNullableDateInput } from '../zod-helpers/index.js';
import { MAX_TRANSFER_ORDER_LINES_PER_CREATE } from './constraints.js';
import { isShipDateTooFarAhead } from './is-ship-date-too-far-ahead.js';
import { lowercasedNullableUuidString } from './lowercased-nullable-uuid-string.js';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
import { MAX_TRANSFER_ORDER_TRACKING_NUM_LENGTH } from './max-transfer-order-tracking-num-length.js';
import { SHIP_DATE_FUTURE_MESSAGE } from './ship-date-future-message.js';
import { shipTransferOrderPickInputSchema } from './ship-transfer-order-pick-input.js';
export const shipTransferOrderInputSchema = z
    .object({
    id: lowercasedRequiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
    carrierId: lowercasedNullableUuidString('Invalid carrier selection.').optional(),
    carrierServiceId: lowercasedNullableUuidString('Invalid carrier service selection.').optional(),
    trackingNum: z
        .string()
        .max(MAX_TRANSFER_ORDER_TRACKING_NUM_LENGTH, `Tracking number must be ${MAX_TRANSFER_ORDER_TRACKING_NUM_LENGTH} characters or fewer.`)
        .transform((value) => value.trim() || null)
        .nullish(),
    dateShipped: optionalNullableDateInput,
    expectedPicks: z
        .array(shipTransferOrderPickInputSchema)
        .max(MAX_TRANSFER_ORDER_LINES_PER_CREATE)
        .nullish(),
})
    .superRefine((values, context) => {
    if (values.carrierId === null) {
        context.addIssue({
            code: 'custom',
            path: ['carrierId'],
            message: 'Choose a carrier to ship with.',
        });
    }
    if (values.carrierServiceId && !values.carrierId) {
        context.addIssue({
            code: 'custom',
            path: ['carrierId'],
            message: 'Choose a carrier for the carrier service.',
        });
    }
    if (values.dateShipped && isShipDateTooFarAhead(values.dateShipped)) {
        context.addIssue({
            code: 'custom',
            path: ['dateShipped'],
            message: SHIP_DATE_FUTURE_MESSAGE,
        });
    }
    const itemIds = (values.expectedPicks ?? []).map((pick) => pick.itemId);
    if (new Set(itemIds).size !== itemIds.length) {
        context.addIssue({
            code: 'custom',
            path: ['expectedPicks'],
            message: 'Each line item can appear only once.',
        });
    }
});
//# sourceMappingURL=ship-input.js.map